import React from 'react'
import ProgramListAdsContainer from '../../containers/PageEditSelection/ProgramListAdsContainer'
import ProgramListHighlightsContainer from '../../containers/PageEditSelection/ProgramListHighlightContainer'
import ProgramListMoviesContainer from '../../containers/PageEditSelection/ProgramListMoviesContainer'
import ProgramListWeischerAdContainer from '../../containers/PageEditSelection/ProgramListWeischerAdContainer'
import ProgramListAdvertisementContainer from '../../containers/PageEditSelection/ProgramListAdvertisementContainer'
import { ADVERTISEMENT } from '../../constants/itemTypes'


const Program = ({
    displayMovies, 
    displayAds, 
    displayAdvertisements, 
    displayHighlights, 
    displayWeischer, 
    isAllOpen,
    setAllOpen,
}) => (
    <div>
        {displayWeischer && <ProgramListWeischerAdContainer
            type={'weischer'}
            titleTransId='program_list_weischer_selection'
            buttonTextTransId="program_list_button_new_ad"
            className={'weischer-content'}
            isAllOpen={isAllOpen}
            setAllOpen={setAllOpen}
        />}

        {displayAdvertisements && <ProgramListAdvertisementContainer
            type={ADVERTISEMENT}
            titleTransId="program_list_advertisement_selection"
            buttonTextTransId="program_list_button_new_advertisement"
            className={'content-content'}
            isAllOpen={isAllOpen}
            setAllOpen={setAllOpen}
        />}

        {displayAds && <ProgramListAdsContainer 
            type={'ad'}
            titleTransId="program_list_content_selection"
            buttonTextTransId="program_list_button_new_content"
            className={'content-content'}
            isAllOpen={isAllOpen}
            setAllOpen={setAllOpen}
        />}

       {displayMovies && <ProgramListMoviesContainer 
            type={'movie'}
            titleTransId="program_list_movie_selection"
            className={'film-content'}
            isAllOpen={isAllOpen}
            setAllOpen={setAllOpen}
        />}
       
       {displayHighlights && <ProgramListHighlightsContainer 
            type={'highlight'}
            titleTransId="program_list_highlight_selection"
            buttonTextTransId="program_list_button_new_highlight"
            className={'highlight-content'}
            isAllOpen={isAllOpen}
            setAllOpen={setAllOpen}
        />}
    </div>
)

export default Program